var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencilSquare = function SvgPencilSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.356 21.47q-.758 0-1.283-.526a1.75 1.75 0 0 1-.525-1.282V6.277q0-.758.525-1.283t1.283-.525h8.656l-1.5 1.5H4.356a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v13.385q0 .114.096.211a.3.3 0 0 0 .212.096H17.74a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212v-7.219l1.5-1.5v8.72q0 .757-.525 1.282t-1.283.525zm4.192-6v-3.434l9.06-9.059q.232-.232.511-.34.279-.106.568-.106.294 0 .565.107.271.105.494.33l1.256 1.251q.217.233.334.514.116.28.116.569t-.1.56q-.098.27-.33.503l-9.09 9.104zm1.5-1.5h1.246l6.233-6.233-.623-.623-.667-.643-6.189 6.189z"
  })));
};
export default SvgPencilSquare;